import { NgModule } from '@angular/core';
import { PermissionsDirective } from './permissions.directive';

@NgModule({
  imports: [],
  declarations: [PermissionsDirective],
  exports: [PermissionsDirective]
})
export class AppDirectivesModule {}
